/// Statut de publication d'un cours/module/leçon
export enum PublishStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED',
}

/// Difficulté d'un cours (1-5)
export enum Difficulty {
  DISCOVERY = 1, // Découverte
  BEGINNER = 2, // Débutant
  INTERMEDIATE = 3, // Intermédiaire
  ADVANCED = 4, // Avancé
  EXPERT = 5, // Expert
}

/// Type de contenu d'une leçon
export enum LessonType {
  ARTICLE = 'ARTICLE', // Texte riche (Markdown)
  VIDEO = 'VIDEO', // Vidéo embarquée
  EXERCISE = 'EXERCISE', // Exercice interactif
  QUIZ = 'QUIZ', // Quiz de validation
}

/// Statut de progression d'un user sur une leçon
export enum ProgressStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}
